//region :: Imports ::
import {ReactElement} from 'react';
import MComponent from '../Component';
import {MBoolean} from './Control';
import {MSaveIconName} from '../../Icons';
import MButton from './Button';

//endregion

/** */
type Props = {
    formId: string;
    iconOnly?: boolean;
    tooltip?: string;
    isBusy: MBoolean;
    disabled: MBoolean;
}

/** */
class MSaveButton extends MComponent<Props> {

    /** */
    public constructor(props: Props) {
        super(props);

    }

    /** */
    public render(): ReactElement {

        return (
            <MButton formId={this.props.formId}
                     label="Save"
                     type="submit"
                     color="success"
                     icon={MSaveIconName}
                     iconOnly={this.props.iconOnly ?? true}
                     tooltip={this.props.tooltip ?? 'Save'}
                     isBusy={this.props.isBusy}
                     disabled={this.props.disabled}/>
        );

    }

}

export default MSaveButton;